import { normalizeCropCode } from "pages/admin/experiments/cropExtraction/cropCodes";
import { findField, findTable, runDbfParser, toNumber, toString } from "pages/admin/experiments/cropExtraction/parsers/genericDbf";
import { ParserResult } from "pages/admin/experiments/cropExtraction/types";

export const parseHessenPolygone = (zipBuffer: ArrayBuffer): Promise<ParserResult> =>
  runDbfParser(zipBuffer, {
    notFoundMessage: "Could not read Hessen Antrags*_POLYGONE DBF",
    pickTable: (tables) => findTable(tables, (b) => b.includes("antragsschlage") || b.includes("antragsflachen")) ?? tables[0],
    buildExtractor: (table) => {
      const cropCol = findField(table.rows, ["ncode_aktu", "nzng_aktue", "ncode"]);
      const fieldNameCol = findField(table.rows, ["lage_bez", "schlagbez", "schlag_bez", "bezeichnung"]);
      const fieldIdCol = findField(table.rows, ["schlagnr_a", "schlagnr", "schlag_id", "fid"]);
      const areaCol = findField(table.rows, ["beantr_gro", "netto_groe", "flaeche_ha", "flaeche"]);
      const flikCol = findField(table.rows, ["flik_aktue", "flik"]);

      return (row) => {
        const fieldId = fieldIdCol ? toString(row[fieldIdCol]) : "";
        const fieldName = fieldNameCol ? toString(row[fieldNameCol]) : "";
        const flik = flikCol ? toString(row[flikCol]) : "";
        return {
          fieldId: fieldId || flik,
          fieldName: fieldName || fieldId || flik,
          cropCode: normalizeCropCode(cropCol ? toString(row[cropCol]) : ""),
          cropDescription: "",
          areaHa: areaCol ? toNumber(row[areaCol]) : 0,
          fieldNumber: fieldId || undefined,
        };
      };
    },
  });
